import { Alert, Box, Typography, Button, Link as JoyLink } from '@mui/joy';
import WorkIcon from '@mui/icons-material/Work';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

const DISMISS_NON_ATS_CREATE = 'non-ats-banner-dismissed-create';

const NonATSOnboardingBanner = ({ onVisible }) => {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_NON_ATS_CREATE) === '1'
  );

  const visible = !dismissed;

  useEffect(() => {
    onVisible?.(visible);
  }, [visible, onVisible]);

  if (!visible) return null;

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_NON_ATS_CREATE, '1');
    setDismissed(true);
  };

  return (
    <Alert
      color="primary"
      variant="soft"
      startDecorator={<WorkIcon />}
      sx={{ mb: 2 }}
      endDecorator={
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Button
            size="sm"
            variant="solid"
            color="primary"
            onClick={() => navigate('/onboarding/job/new?next=invite-candidates')}
          >
            Create job
          </Button>
          <JoyLink
            level="body-sm"
            color="neutral"
            component="button"
            onClick={dismiss}
          >
            Remind me later
          </JoyLink>
        </Box>
      }
    >
      <Box>
        <Typography level="title-sm">Next step - create your first job</Typography>
        <Typography level="body-xs">
          Set up the role, interview, and candidate invite link.
        </Typography>
      </Box>
    </Alert>
  );
};

export default NonATSOnboardingBanner;
